'use strict';
var isPathInside = require('is-path-inside');

module.exports = function (str) {
	return isPathInside(str, process.cwd());
};



//////////////////
// WEBPACK FOOTER
// ./~/is-path-in-cwd/index.js
// module id = 901
// module chunks = 0